// Location: src/features/devices/config/metadataKeys.ts

// Known raw metadata keys map to a translated label; anything unmapped is
// humanised from the key instead of shown verbatim, so an internal product
// name never reaches the UI (F-B-014 — technology concealment). Shared by
// DeviceList.tsx (list indicator) and DeviceEdit.tsx (detail section).
const METADATA_KEY_TRANSLATION_KEYS: Record<string, string> = {
  consoleDeviceId: 'resources.devices.metadataKeys.deviceId',
  consoleEstablishmentId: 'resources.devices.metadataKeys.establishmentId',
  consoleHotelId: 'resources.devices.metadataKeys.establishmentId',
  consoleGroupId: 'resources.devices.metadataKeys.groupId',
  model: 'resources.devices.metadataKeys.model',
  firmware: 'resources.devices.metadataKeys.firmware',
};

export const humanizeMetadataKey = (key: string, translate: (k: string, opts?: any) => string): string => {
  const translationKey = METADATA_KEY_TRANSLATION_KEYS[key];
  if (translationKey) return translate(translationKey);
  // Unmapped key: strip a leading internal-product prefix (never surfaced)
  // and humanise the remainder (camelCase/snake_case -> "Title Case").
  const withoutPrefix = key.replace(/^console/i, '') || key;
  return withoutPrefix
    .replace(/[_-]/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/^./, (c) => c.toUpperCase())
    .trim();
};
